import closeIcon from '@/components/Icons/Modals/IconClose.vue';
import { async } from 'q';

export default{
	mounted(){
		// setTimeout(() => this.modalActive = true, 300);
	},

	data(){
		return{
			id: null,
			modalActive: false,
			responseReady: false,
			success: '',
			editUserSuccess: false,

			typeSelectFlag: false,
			tempSelect: "Selecciona...",

			///////////////
			//// CREATE USER
			// editUser:{
			// 	password: "",
			// 	newPassword: "",
			// 	newPasswordConfirm: "",
			// 	email: "",
			// 	type: ""
			// },
			
			options: [
				{label: 'Administrador', value: 'admin'},
				{label: 'Consejo', value: 'comun'}
			]
		}
	},

	// props: ['section'],
	
	components:{
		closeIcon,
	},

	methods:{
		closeModal(){

			this.$parent.modal_editUser = false;
			this.editUserSuccess = false;

		},
		editUser(scope){
			this.$validator.validateAll(scope).then((result) => {
				if(result){

					(async () => {
			
						await fetch('https://api.salonacme.com/manager/update_user_admin', {
							method: 'POST',
							headers:{
							'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								_id: this.$session.get('_id'),
								user: this.$parent.editUserData
							})
						}).then(async response => {
							response = await response.json();
							if(response.status)
							{

								// Usuario Editado
								this.$parent.get_users(null, null);
								this.closeModal();
								/** Alert */
								this.$parent.alert_temp = { status: true,
									type: "success",
									label: "Usuario Editado"
								  };
								  setTimeout(  () => {this.$parent.alert_temp.status = false;}, 3000);
								  /** FIN Alerta */
								// console.log(response);

								/// edit myself
								if( String(this.$parent.editUserData._id) == String(this.$session.get('_id')) ){
									this.$session.set('name',this.$parent.editUserData.name);
									this.$session.set('email',this.$parent.editUserData.email);
									setTimeout(() => {
										location.reload(true);
									}, 500);
								}


							}else{
							alert(response.msg);
							}
						})
						.catch(error => alert(error));
					})();
		
				}
			});
		}
	},

	watch: {
		'$parent.modal_editUser': function (newQuestion) {
			if(this.$parent.modal_editUser){
				for (let index = 0; index < this.options.length; index++) {
					if(this.options[index].value == this.$parent.editUserData.type){
						this.tempSelect = this.options[index].label;
						this.errors.clear();
					}
				}
			}
		}
	},
	mounted(){
		// console.log(this.$parent.baseUrl);
	}
}